/**
 * Delivery money helpers. Two different units meet on this page: the fees the
 * player paid (decimal amounts in the operator's currency, snapshotted at
 * checkout) and the locked FMV of a card (always USD cents, because that is
 * what the outcome log records). Mixing them up would misprice a delivery, so
 * each has its own formatter.
 */

export function formatAmount(amount: string | number | null, currency: string | null): string {
  if (amount === null || amount === '') return '—';

  const value = typeof amount === 'string' ? Number(amount) : amount;
  if (Number.isNaN(value)) return '—';

  return `${value.toFixed(2)}${currency ? ` ${currency}` : ''}`;
}

export function formatUsdCents(cents: number | null): string {
  if (cents === null) return '—';

  return `$${(cents / 100).toFixed(2)}`;
}
